import React from 'react'
import classnames from 'classnames'
import SelectComponent from 'pu-react/components/base/SelectComponent';
import PropTypes from 'prop-types'

const options = [
  { value: 'FR4/Leaded Solder', text: 'FR4 Tg135 / Leaded Solder' },
  { value: 'FR4TG180/ENIG', text: 'FR4 Tg180 / ENIG' },
  { value: 'FR4TG180/Lead Free Solder', text: 'FR4 Tg180 / Lead Free Solder' },
  { value: 'FR4TG180/Immersion Silver', text: 'FR4 Tg180 / Immersion Silver' },
  { value: 'FR4TG180/Bare Copper', text: 'FR4 Tg180 / Bare Copper' },
  { value: 'FR4TG180/OSP', text: 'FR4 Tg180 / OSP' },
];

const tooltip = null

const MaterialTypeAndFinishPlating = (props) => {
  const name = 'material_type_finish_plating';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={name}
      onChange={props.onChange || onChange}
      options={props.options}
      tooltip={tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName}
      className={classnames('material-type', props.className)}/>
  )
};

MaterialTypeAndFinishPlating.defaultProps = {
  options,
  label: 'Material Type / Finish Plating',
  required: true,
}

MaterialTypeAndFinishPlating.propTypes = {
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
}

export default MaterialTypeAndFinishPlating;
